/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Feedback_List_SuccessInputs */

const es_tools_nexata_feedback_list_success = /** @type {(inputs: Tools_Nexata_Feedback_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback cargado`)
};

const en_tools_nexata_feedback_list_success = /** @type {(inputs: Tools_Nexata_Feedback_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback loaded`)
};

/**
* | output |
* | --- |
* | "Feedback loaded" |
*
* @param {Tools_Nexata_Feedback_List_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_feedback_list_success = /** @type {((inputs?: Tools_Nexata_Feedback_List_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Feedback_List_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_feedback_list_success(inputs)
	return en_tools_nexata_feedback_list_success(inputs)
});
export { tools_nexata_feedback_list_success as "tools.nexata.feedback_list_success" }